import './sobremi.css'

function SobreMi() {
    return (
        <div className='sobremi_container' id='sobremi'>
            <div className="sobremi_texto">
                <h3>SOBRE MÍ</h3>
                <p>Soy <span className="highlight">Lautaro Mazza</span>, cantante de tango con más de 20 años de trayectoria y una vocación profunda por la interpretación del tango. Mi formación comenzó en la Casa del Tango de La Plata y se consolidó con el Maestro Mario Bracco, con quien trabajé intensamente durante más de una década. Actualmente continúo mi perfeccionamiento junto a la prestigiosa Maestra Emilce Vasaro, profundizando una línea de trabajo centrada en la técnica vocal al servicio de mi interpretación del género.</p>
                
                <p>
                    Desde 2014 integro la Orquesta del Tango de la Ciudad de Buenos Aires, dirigida por los Maestros Juan Carlos Cuacci y Néstor Marconi.
                </p>
                
                <p>Soy invitado permanente de la Orquesta Nacional de Música Argentina "Juan de Dios Filiberto" y de la Orquesta de Tango de la UNA (Universidad Nacional de las Artes) dirigida por el Maestro Ariel Pirotti.</p>
                
                <p>Tuve el honor de ser el último cantor del Maestro Raúl Garello, una de las figuras más emblemáticas del tango. A lo largo de mi carrera, he sido elegido especialmente para proyectos junto a referentes como Néstor Marconi, Juan Carlos Cuacci y Rodolfo Mederos, entre otros.</p>
                
                <p>He cantado en escenarios de gran prestigio, como el <span className="highlight">Teatro Colón</span>, la Usina del Arte, el Centro Cultural Kirchner, el Teatro San Martín, el Luna Park y salas internacionales de México, Colombia, Ecuador y Brasil.</p>
            </div>
            <div className="sobremi_foto">
            </div>
        </div>
    )
}

export default SobreMi